import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import App from "./App";
import Iframe from "./components/dti/Iframe";

const root = ReactDOM.createRoot(document.getElementById("statistics-main"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/iframes/:id" element={<Iframe />} />
        <Route path="/iframes" element={<Iframe />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
